import DropdownMixin from './mixins/dropdown.vue';

export default {
    name: 'MultiSelect',
    template: '#realty-search-multi-select',
    mixins: [DropdownMixin],
    props: {
        value: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        values: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
        name: {
            type: String,
            required: true,
        },
        idStub: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            dirty: false,
            selection: new Map(),
            selectionCt: 0,
        };
    },
    watch: {
        value(newVal) {
            this.valueToSelection(newVal);
        },
    },
    computed: {
        selectedItems() {
            return this.selectionCt && this.selection;
        },
        screenValue() {
            if (this.value && this.value.length) {
                return ''; // unused
            }

            return this.dirty ? 'egal' : this.placeholder;
        },
    },
    mounted() {
        if (this.value && this.value.length) {
            this.dirty = true;
            this.valueToSelection(this.value);
        }
    },
    methods: {
        valueToSelection(value) {
            this.selection = new Map();

            value.forEach((val) => {
                let item = this.values.find(({ value }) => value === val);

                if (item) {
                    this.selection.set(val, item);
                }
            });

            this.selectionCt = this.selection.size;
        },
        clearValue(value) {
            this.selection.delete(value);
            this.selectionCt = this.selection.size;

            this.$emit('input', Array.from(this.selection.keys()));
        },
        onInput(event, value) {
            const checkbox = event.target;

            this.dirty = true;

            if (checkbox.checked) {
                this.selection.set(value.value, value);
                this.selectionCt = this.selection.size;

                this.$emit('input', Array.from(this.selection.keys()));
            }
        },
        isChecked({ value }) {
            return this.selection.has(value);
        },
    },
};
